/* eslint-disable func-names */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";
import {
    Badge,
    Button,
    Card,
    Form,
    Navbar,
    Nav,
    Container,
    Row,
    Col,
    Table,
    Modal
  } from "react-bootstrap";

import {BsFillSuitHeartFill} from "react-icons/bs";
import { login } from "../../actions";
import { getTranslate, LANGUAGE_KEYS } from '../../utils/language';
import { getPublicCompanyByShortcode } from '../../services/companyService';
import { getApiUrl } from '../../utils/platform';

class LoginChecker extends Component {
  constructor() {
    super();
    this.state = {
      username: '',
      password: '',
      companyInfo: null,
      companyLoading: true,
      companyError: null,
      loginError: null,
      backgroundColor: 'rgba(255, 255, 255, 0.5)',
      animationLoading: true
    };
  }

  componentDidMount() {
    this.loadCompanyInfo();
    // Clear any existing login error when component mounts
    this.setState({ loginError: null });
    
    // Add CSS animation to head
    this.addCSSAnimation();
    
    // Initialize Vanta.js animation only if REACT_APP_VANTA is enabled
    if (process.env.REACT_APP_VANTA === '1') {
      setTimeout(() => {
        this.initVantaAnimation();
      }, 100);
    } else {
      // Skip Vanta animation and use fallback
      this.setState({ animationLoading: false });
      this.startDynamicBackground();
    }
  }

  componentWillUnmount() {
    // Clean up Vanta.js animation
    if (this.vantaEffect) {
      this.vantaEffect.destroy();
    }
    // Clean up background animation
    if (this.backgroundInterval) {
      clearInterval(this.backgroundInterval);
    }
  }

  componentWillReceiveProps(props) {
    // Check for login error
    if (props.loginError && !this.state.loginError) {
      this.setState({ loginError: 'Tên đăng nhập hoặc mật khẩu không đúng' });
    }
  }

  loadCompanyInfo = async () => {
    try {
      // Extract shortcode from URL
      const hostname = window.location.hostname;
      let shortcode = hostname.split('.')[0]; // Get subdomain part
      
      // Handle localhost case - use "ksc" for testing
      if (hostname === 'localhost' || hostname === '127.0.0.1') {
        shortcode = 'tkt1';
      }
      
      if (shortcode && shortcode !== 'www' && shortcode !== 'TKT1') {
        const response = await getPublicCompanyByShortcode(shortcode);
        if (response.data && response.data.status === 1) {
          this.setState({ 
            companyInfo: response.data.data,
            companyLoading: false 
          });
        } else {
          this.setState({ 
            companyError: 'Company not found',
            companyLoading: false 
          });
        }
      } else {
        // Default TKT1 company
        this.setState({ 
          companyInfo: {
            name: 'TKT1',
            legal_name: 'TKT1 Technology',
            logo: '/TKT1_logo.png',
            description: 'TKT1 Platform'
          },
          companyLoading: false 
        });
      }
    } catch (error) {
      console.error('Error loading company info:', error);
      this.setState({ 
        companyError: 'Failed to load company info',
        companyLoading: false 
      });
    }
  }

  handleChangeUsername = (e) => {
    this.setState({ 
      username: e.target.value,
      loginError: null // Clear error when user types
    });
  }

  handleChangePassword = (e) => {
    this.setState({ 
      password: e.target.value,
      loginError: null // Clear error when user types
    });
  }

  handleSubmit = (e) => {
    e.preventDefault();

    // Use company_id from companyInfo
    const company_id = this.state.companyInfo?.company_id || '';
    this.props.login(this.state.username, this.state.password, company_id);
  }

  // Vanta.js animation methods
  initVantaAnimation = () => {
    const element = document.getElementById('animation-canvas');
    if (!element) {
      console.log('Animation element not found, retrying...');
      setTimeout(() => this.initVantaAnimation(), 100);
      return;
    }

    console.log('Initializing Vanta.js HALO effect...');
    
    // Load Vanta.js scripts if not already loaded
    this.loadVantaScripts().then(() => {
      try {
        // Check if Three.js is properly loaded
        if (!window.THREE || !window.THREE.Color) {
          throw new Error('Three.js not properly loaded');
        }
        
        this.vantaEffect = window.VANTA.HALO({
          el: "#animation-canvas",
          mouseControls: true,
          touchControls: true,
          gyroControls: false,
          minHeight: 200.00,
          minWidth: 200.00,
          backgroundColor: 0x131a43,
          baseColor: 0x1a59,
          size: 1.0,
          amplitudeFactor: 1.0,
          xOffset: 0,
          yOffset: 0
        });
        
        console.log('Vanta.js HALO effect initialized');
        
        // Hide loading screen
        this.setState({ animationLoading: false });
        
        // Start dynamic background color animation
        this.startDynamicBackground();
      } catch (error) {
        console.error('Error initializing Vanta.js:', error);
        this.handleVantaError();
      }
    }).catch(error => {
      console.error('Failed to load Vanta.js scripts:', error);
      this.handleVantaError();
    });
  }

  addCSSAnimation = () => {
    // Check if CSS animation already exists
    if (document.getElementById('tkt1-spin-animation')) return;
    
    const style = document.createElement('style');
    style.id = 'tkt1-spin-animation';
    style.textContent = `
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `;
    document.head.appendChild(style);
  }

  handleVantaError = () => {
    console.log('Falling back to gradient background');
    
    // Set gradient background as fallback
    const canvas = document.getElementById('animation-canvas');
    if (canvas) {
      canvas.style.background = 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)';
    }
    
    // Hide loading screen
    this.setState({ animationLoading: false });
    
    // Start dynamic background color animation
    this.startDynamicBackground();
  }

  loadVantaScripts = () => {
    return new Promise((resolve, reject) => {
      // Check if scripts are already loaded
      if (window.THREE && window.VANTA) {
        resolve();
        return;
      }

      let loadedCount = 0;
      const totalScripts = 2;

      const onScriptLoad = () => {
        loadedCount++;
        if (loadedCount === totalScripts) {
          // Wait a bit more for Three.js to be fully ready
          setTimeout(() => {
            resolve();
          }, 100);
        }
      };

      const onScriptError = (error) => {
        reject(error);
      };

      // Load Three.js
      if (!window.THREE) {
        const threeScript = document.createElement('script');
        threeScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/three.js/r134/three.min.js';
        threeScript.onload = onScriptLoad;
        threeScript.onerror = onScriptError;
        document.head.appendChild(threeScript);
      } else {
        onScriptLoad();
      }

      // Load Vanta.js HALO
      if (!window.VANTA) {
        const vantaScript = document.createElement('script');
        vantaScript.src = 'https://cdn.jsdelivr.net/npm/vanta@latest/dist/vanta.halo.min.js';
        vantaScript.onload = onScriptLoad;
        vantaScript.onerror = onScriptError;
        document.head.appendChild(vantaScript);
      } else {
        onScriptLoad();
      }
    });
  }

  // Dynamic background color animation
  startDynamicBackground = () => {
    const colors = [
      'rgba(102, 126, 234, 0.3)',   // Blue
      'rgba(118, 75, 162, 0.3)',   // Purple
      'rgba(255, 255, 255, 0.3)',  // White
      'rgba(102, 126, 234, 0.4)',  // Blue darker
      'rgba(118, 75, 162, 0.4)',   // Purple darker
      'rgba(255, 255, 255, 0.4)',  // White darker
      'rgba(102, 126, 234, 0.2)',  // Blue lighter
      'rgba(118, 75, 162, 0.2)',   // Purple lighter
    ];

    let colorIndex = 0;
    
    this.backgroundInterval = setInterval(() => {
      this.setState({
        backgroundColor: colors[colorIndex]
      });
      
      colorIndex = (colorIndex + 1) % colors.length;
    }, 2000); // Change color every 2 seconds
  }

  render() {
    const { companyInfo, companyLoading, companyError, loginError, backgroundColor, animationLoading } = this.state;

    if (companyLoading) {
      return (
        <div className="vh-100 d-flex justify-content-center align-items-center" style={{
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
        }}>
          <div className="text-center text-white">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-3">Loading company information...</p>
          </div>
        </div>
      );
    }

    if (companyError) {
      return (
        <div className="vh-100 d-flex justify-content-center align-items-center" style={{
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
        }}>
          <div className="text-center text-white">
            <h4>Error</h4>
            <p>{companyError}</p>
            <Button variant="light" onClick={() => window.location.href = 'https://TKT1.ai'}>
              Go to TKT1
            </Button>
          </div>
        </div>
      );
    }

    return (
      <div style={{
          minHeight: '100vh',
          position: 'relative',
          overflow: 'hidden'
        }}>
        {/* Loading Screen */}
        {animationLoading && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 2000
          }}>
            <div style={{
              textAlign: 'center',
              color: 'white'
            }}>
              <div style={{
                width: '60px',
                height: '60px',
                border: '4px solid rgba(255, 255, 255, 0.3)',
                borderTop: '4px solid white',
                borderRadius: '50%',
                animation: 'spin 1s linear infinite',
                margin: '0 auto 20px'
              }} />
              <h2 style={{
                fontSize: '2rem',
                fontWeight: '700',
                marginBottom: '10px',
                textShadow: '0 2px 4px rgba(0,0,0,0.3)'
              }}>
                TKT1
              </h2>
              <p style={{
                fontSize: '1rem',
                opacity: 0.8,
                textShadow: '0 1px 2px rgba(0,0,0,0.3)'
              }}>
                Loading Magic...
              </p>
            </div>
          </div>
        )}

        {/* Full Screen Animation Canvas */}
        <div 
          id="animation-canvas" 
          style={{
            width: '100vw',
            height: '100vh',
            position: 'fixed',
            top: 0,
            left: 0,
            zIndex: 1
          }}
        />

        {/* Login Form Overlay - Centered */}
        <div style={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '400px',
          zIndex: 1000
        }}>
          {/* Login Card */}
          <Card className="shadow-lg border-0" style={{
            borderRadius: '16px',
            backdropFilter: 'blur(10px)',
            backgroundColor: backgroundColor,
            boxShadow: '0 20px 40px rgba(0, 0, 0, 0.1)',
            transition: 'background-color 1s ease-in-out'
          }}>
            <Card.Body className="p-4">
              <div className="text-center mb-4">
                <h3 className="fw-bold mb-2" style={{color: "white"}}>
                  TKT1 LOGIN
                </h3>
              </div>
                
                {/* Login Error Message */}
                {loginError && (
                  <div className="mb-3 p-3" style={{
                    backgroundColor: '#f8d7da',
                    border: '1px solid #f5c6cb',
                    borderRadius: '8px',
                    color: '#721c24'
                  }}>
                    <div className="d-flex align-items-center">
                      <span style={{ marginRight: '8px' }}>⚠️</span>
                      <span style={{ fontSize: '14px' }}>{loginError}</span>
                    </div>
                  </div>
                )}
                
                <Form onSubmit={this.handleSubmit}>
                  <Form.Group className="mb-3" controlId="formBasicUsername">
                    <Form.Label className="fw-semibold small" style={{color: "white"}}>
                      USERNAME
                    </Form.Label>
                    <Form.Control 
                      type="text" 
                      placeholder="Enter username" 
                      onChange={this.handleChangeUsername}
                      style={{ 
                        borderRadius: '8px',
                        border: '1px solid #e0e0e0',
                        padding: '12px 16px',
                        fontSize: '14px'
                      }}
                    />
                  </Form.Group>

                  <Form.Group className="mb-4" controlId="formBasicPassword">
                    <Form.Label className="fw-semibold small" style={{color: "white"}}>
                      PASSWORD
                    </Form.Label>
                    <Form.Control 
                      type="password" 
                      placeholder="Enter password" 
                      onChange={this.handleChangePassword}
                      style={{ 
                        borderRadius: '8px',
                        border: '1px solid #e0e0e0',
                        padding: '12px 16px',
                        fontSize: '14px'
                      }}
                    />
                  </Form.Group>

                  <div className="d-grid mb-3">
                    <Button 
                      variant="primary" 
                      type="submit"
                      style={{ 
                        borderRadius: '8px',
                        background: '#667eea',
                        border: 'none',
                        padding: '12px 16px',
                        fontSize: '16px',
                        fontWeight: '600',
                        color: 'white',
                        boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)',
                        transition: 'all 0.3s ease'
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.background = '#5a6fd8';
                        e.target.style.transform = 'translateY(-1px)';
                        e.target.style.boxShadow = '0 6px 16px rgba(102, 126, 234, 0.4)';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.background = '#667eea';
                        e.target.style.transform = 'translateY(0)';
                        e.target.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.3)';
                      }}
                    >
                      LOGIN
                    </Button>
                  </div>
                </Form>
                
                {/* Footer */}
                <div className="text-center mt-3">
                  <p className="small mb-0" style={{color: "white"}}>
                    <strong>Where Magic Happens</strong>
                  </p>
                </div>
              </Card.Body>
            </Card>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    token: state.authenReducer.token,
    loginError: state.authenReducer.error
  };
};

export default connect(mapStateToProps, { login })(LoginChecker);